<template>
  <tr @click="handleItemClick" :style="{'cursor': 'pointer'}">
    <td>{{ item.title }}</td>
    <td>{{ item.email | NoEmpty }}</td>
    <td>{{ item.inviteToDpCasesEmails | NoEmpty }}</td>
    <td>{{ caseOriginator.name | NoEmpty }}</td>
    <td>{{ originatorClientIds | NoEmpty }}</td>
    <td>{{ reportSendMode.name | NoEmpty }}</td>
    <td>{{ noHeader.name | NoEmpty }}</td>
    <td>{{ noStamp.name | NoEmpty }}</td>
    <td>{{ item.skipCalcStat ? 'Yes' : 'No'}}</td>
    <td>{{ allCostCentersMap[item.costCenterId] | NoEmpty }}</td>
    <td>{{ allRegionsMap[item.regionId] | NoEmpty }}</td>
    <td>{{ item.address | NoEmpty }}</td>
    <td>
      <v-btn small flat icon color="black lighten-2" class="actionButton" @click.stop.prevent="handleEditButtonClick">
        <v-icon small>fas fa-pencil-alt</v-icon>
      </v-btn>

      <v-btn small flat icon color="black lighten-2" class="actionButton" @click.stop.prevent="handleDeleteButtonClick">
        <v-icon small>fas fa-trash-alt</v-icon>
      </v-btn>

      <edit-client-invoice-email-form class="actionButton" :client-id="item.id"/>
    </td>
  </tr>
</template>

<script>
import {showApiError} from '../../helpers/notification.js'
import api from '../../api'
import NoEmpty from '../Filters/NoEmpty'
import EditClientInvoiceEmailForm from '../../components/clients/EditClientInvoiceEmailForm'
import _ from 'lodash'

import { mapState } from 'vuex'

export default {
  name: 'client-item',
  props: {
    item: {
      type: Object
    },
    caseOriginators: {
      type: Array
    },
    caseOriginatorsById: {
      type: Object
    },
    availableReportSendModesByValue: {
      type: Object
    },
    availableReportSendModes: {
      type: Array
    }
  },
  filters: {
    NoEmpty
  },
  components: {
    EditClientInvoiceEmailForm
  },
  data () {
    return {
      validatableRefs: ['title'],
      draft: {
        id: this.item.id,
        title: this.item.title,
        email: this.item.email,
        inviteToDpCasesEmails: this.item.inviteToDpCasesEmails,
        caseOriginatorId: this.item.caseOriginatorId,
        originatorClientIds: this.item.originatorClientIds,
        reportSendMode: this.item.reportSendMode,
        noHeader: this.item.noHeader,
        noStamp: this.item.noStamp
      },
      yesNoValues: [ { value: true, name: 'Yes' }, { value: false, name: 'No' } ],
      titleRules: [
        v => !!v || 'Enter client title',
        v => (v && v.length <= 1000) || 'The length of the name should be no more than 1000 characters'
      ]
    }
  },
  beforeCreate () {

  },
  computed: {
    ...mapState({
      allCostCentersMap: 'allCostCentersMap',
      allRegionsMap: 'allRegionsMap'
    }),
    yesNoByValue () {
      return _.keyBy(this.yesNoValues, 'value')
    },
    title: {
      get: function () {
        return this.item.title
      },
      set: function (newValue) {
        this.draft.title = newValue
      }
    },
    email: {
      get: function () {
        return this.item.email
      },
      set: function (newValue) {
        if (newValue.length === 0) {
          newValue = null
        }

        this.draft.email = newValue
      }
    },
    inviteToDpCasesEmails: {
      get: function () {
        return this.item.inviteToDpCasesEmails
      },
      set: function (newValue) {
        if (newValue.length === 0) {
          newValue = null
        }

        this.draft.inviteToDpCasesEmails = newValue
      }
    },
    caseOriginator: {
      get: function () {
        return _.get(this.caseOriginatorsById, [this.item.caseOriginatorId], {})
      },
      set: function (newValue) {
        this.draft.caseOriginatorId = newValue
      }
    },
    originatorClientIds: {
      get: function () {
        return _.join(this.item.originatorClientIds, ', ')
      },
      set: function (newValue) {
        this.draft.originatorClientIds = _.filter(_.map(_.split(newValue, ','), (elem) => { return _.trim(elem) }), (id) => { return id.length > 0 })
      }
    },
    reportSendMode: {
      get: function () {
        return _.get(this.availableReportSendModesByValue, [this.item.reportSendMode], {})
      },
      set: function (newValue) {
        this.draft.reportSendMode = newValue
      }
    },
    noHeader: {
      get: function () {
        return _.get(this.yesNoByValue, [this.item.noHeader], {})
      },
      set: function (newValue) {
        this.draft.noHeader = newValue
      }
    },
    noStamp: {
      get: function () {
        return _.get(this.yesNoByValue, [this.item.noStamp], {})
      },
      set: function (newValue) {
        this.draft.noStamp = newValue
      }
    },
    skipCalcStat: {
      get: function () {
        return this.item.skipCalcStat
      },
      set: function (newValue) {
        this.draft.skipCalcStat = newValue
      }
    },
    address: {
      get: function () {
        return this.item.address
      },
      set: function (newValue) {
        this.draft.address = newValue
      }
    }
  },
  watch: {},
  mounted () {
  },
  methods: {
    handleEditButtonClick () {
      this.$emit('editClient', this.item)
    },
    handleItemClick () {
      this.$emit('click', this.item)
    },
    async handleDeleteButtonClick () {
      if (!confirm('Do you want to remove client with title: "' + this.item.title + '"')) {
        return
      }

      try {
        await api.deleteClient(this.item)
        this.$emit('deleted', this.item)
      } catch (e) {
        showApiError(this, e, 'Unable to delete client')
      }
    }
  }
}
</script>

<style scoped>
  .actionButton {
    display: inline-block;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sales/ClientItem.vue